export const ProductSizeInitialValues = (localeCodes, showData) => ({
  code: showData?.data?.code || "",
  label: showData?.data?.label || "",
  localizations: localeCodes.reduce((acc, localeCode) => {
    acc[localeCode] = showData?.data?.localization_contents?.[localeCode] ?? "";
    return acc;
  }, {}),
});
